import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 19,
	viewBox: "0 0 12 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.12116 0.5H11.1158M6.14058 18.5V12.6217M0.736514 12.6217L3.1551 10.2V0.5H9.08142V10.2L11.5 12.6217H0.736514Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPin;
